/**
 * @Author  : Luo
 * @Time    : 2020/5/6 17:18
 * status of store
 */

'use strict'

let store = {
  userPageDate: {
    account: '',
    client: [],
    clientTotal: 0,
    active: 0,
    id: 0
  },
  userVideoDate: {
    account: '',
    stage: 0,
    progress: 0,
    time: 0,
    id: 0
  },
  setUserVideoDate (val) {
    this.userVideoDate = val
  },
  clearUserVideoDate () {
    this.userVideoDate = {}
  },
  setUserPageDate (val) {
    this.userPageDate = val
  },
  clearUserPageDate () {
    this.userPageDate = {}
  }
}

export default store



// WEBPACK FOOTER //
// ./src/api/store.js